<template>
  <div class="flex flex-col gap-5 border-t border-border py-6">
    <div v-for="(item, index) in props.data" :key="`value-proposition-${index}`" class="flex items-center text-text-medium">
      <Icon :name="item.icon" class="mr-3 size-6" />
      <p class="text-base">{{ item.text }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '~/components/icon/Icon.vue'

const props = withDefaults(
  defineProps<{
    data?:
      | {
          icon: string
          text: string
        }[]
      | null
  }>(),
  {
    data: null,
  }
)
</script>
